import React from 'react';

import "./css/Footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookSquare, faTwitterSquare, faInstagram, faWhatsapp, faLinkedin, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { faHeart, faheart, faEnvelope } from "@fortawesome/free-solid-svg-icons";


const Footer = () => {
  return (
    <section className="footer">
    <div className='footer-container'>
        <div className=''>
            <h2>Joujo Safaris</h2>
            <p>
              We believe that travel is more than a journey-its a story waiting to be told. We are known for delivering safe, reliable and inspiring safari experiences. With expert guides and a deep respect for nature, we design journeys that blend comfort, culture, and adventure.
            </p>
            <div className="social-container">
      <a href="https://www.facebook.com/J0ujosafaris" target="_blank" rel="noopener noreferrer" className="social-icon facebook">
        <FontAwesomeIcon icon={ faFacebookSquare} />
      </a>
      <a href="https://x.com/SafarisJoujo" target="_blank" rel="noopener noreferrer" className="social-icon twitter">
        <FontAwesomeIcon icon={ faTwitterSquare} />
      </a>
      <a href="https://www.instagram.com/joujo_safaris" target="_blank" rel="noopener noreferrer" className="social-icon instagram">
        <FontAwesomeIcon icon={ faInstagram} />
      </a>
      <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-icon linkedin">
        <FontAwesomeIcon icon={ faWhatsapp} />
      </a>
      <a href="mailto:support@joujosafaris.com" target="_blank" rel="noopener noreferrer" className="social-icon youtube">
        <FontAwesomeIcon icon={ faEnvelope} />
      </a>
    </div>
        </div>
        
        <div className='footer-container_2'>
          
            <ul>
                <li><a href='/home'>Home</a></li>
                <li><a href='/sitemap'>Sitemap</a></li>
                <li><a href='/terms'>Terms of Service</a></li>
            </ul>
            <ul>
                <li><a href='/careers'>Careers</a></li>
                <li><a href='/about#team'>Our Team</a></li>
                <li><a href='/privacy'>Privacy Policy</a></li>
            </ul>
        </div>
        <div className=''>
            <h2>Social Media</h2>
            <div className='footer-gallery'>
                <img src={require('../assets/image/safari_samburu_best_destination.jpg')} alt="Samburu kenya" />
                <img src={require('../assets/image/woman_on_tour_in_africa.jpg')} alt="Nairobi National Park" />
                <img src={require('../assets/image/best_restaurant_in_kenya.jpg')} alt="Best Restaurant in Kenya" />
                <img src={require('../assets/image/accomodation_kenya_safari_cheap_hotel.jpg')} alt="accomodation kenya safari" />
            </div>
        </div>
    </div>
    <div className='footer-copy'>
        <div></div>
        <p className='text-center'>&copy; Copyright {new Date().getFullYear()}, Joujo Safaris. Made with <FontAwesomeIcon icon={ faHeart} /> by <a href="https://njugunakieti.netlify.app" target='_blank'>Coding Lord</a> </p>
    </div>
    </section>
  );
};

export default Footer;
